export const SHOW_ROUTE_NAMES = {
  LIST: 'show-list',
  DETAIL: 'show-detail',
  EDIT: 'show-edit',
  CREATE: 'show-create',
}

export const SHOWS_ROUTE_NAMES = {
  LIST: 'shows-list',
  DETAIL: 'shows-detail',
  EDIT: 'shows-edit',
  CREATE: 'shows-create',
}
